import { postActivity, patchActivity } from "../../api_routes/user";
import { buildDescription } from "./user_activity_description";

// Creates a NEW row in the DB
export async function startActivitySession({
  action,
  module,
  formValues = {},
  accountId,
  status = "SUCCESS",
  error = null,
}) {
  if (!accountId) {
    console.warn("[startActivitySession] accountId missing - skipping");
    return null;
  }

  const response = await postActivity({
    account_id: accountId,
    action,
    module,
    description: buildDescription(action, module, formValues, error),
    status,
    ...(error && { error_message: error }),
  });
  // Store this as sessionId in component state
  return response?.id ?? null;
}

// UPDATES the existing row (adds action and to description)
export async function appendActivity({
  sessionId,
  action,
  module,
  formValues = {},
  status = null,
  error = null,
}) {
  if (!sessionId) return;

  const payload = {
    action,
    description_append: buildDescription(action, module, formValues, error),
    ...(status === "FAILED" && { status: "FAILED" }), // Don't overwrite an error with SUCCESS
    ...(error && {
      error_message: typeof error === "string" ? error : JSON.stringify(error),
    }),
  };

  return patchActivity(sessionId, payload);
}
